// Matched by bookmaker CODE because the backend sends type: 'traditional' for PLM/KAS.
export const PREDICTION_MARKET_CODES = new Set(['PLM', 'KAS']);

export const isPredictionMarket = (bookmakerCode: string | undefined): boolean => {
  if (!bookmakerCode) return false;
  return PREDICTION_MARKET_CODES.has(bookmakerCode.toUpperCase());
};
